export const MDEDICAL_TREATING_SOURCES_STATUSES = [
	{label: 'N/A', value: 1},
	{label: 'Requested', value: 2},
	{label: 'Chasing', value: 3},
	{label: 'Received', value: 4},
	{label: 'Submitted', value: 5}
];
